<template>
  <RemotePaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-rbut
    data-url="admin/rbu/volume/"
    data-key="volumes"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="rbu-volume-list"
  >
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn text color="primary" @click="editItem(item)"> More </v-btn>
        <v-btn
          v-if="canEditVolumeName"
          text
          color="primary"
          @click="editVolumeName(item)"
        >
          Edit
        </v-btn>

        <v-btn
          v-if="canDeleteVolume()"
          text
          color="primary"
          @click="deleteItem(item)"
        >
          Delete
        </v-btn>
      </div>
    </template>
  </RemotePaginatedList>
</template>

<script>
import { onMounted, ref, watch, computed } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";
import { ACTION_TYPES } from "@/store/types";
import { PERMISSIONS, USER_TYPE } from "@/constants";
import EditRbuVolumeNameDialog from "./EditRbuVolumeNameDialog.vue";

export default {
  name: "RbuVolumeList",
  components: { RemotePaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,
  },
  setup(props, { root, emit }) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };

    const canEditVolumeName = computed(() => {
      if (!root.$store.getters.account) return false;
      return [USER_TYPE.SUPER_ADMIN, USER_TYPE.ADMIN].includes(
        root.$store.getters.account.type
      );
    });

    onMounted(() => {
      refresh(false);
      // reset section table / filter
      root.$store.dispatch(ACTION_TYPES.RBU_RESET_SECTION_TABLE_OPTIONS);
      root.$store.dispatch(ACTION_TYPES.RBU_RESET_SECTION_FILTERS);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    const canDeleteVolume = function () {
      if (!root.$store.getters.account) return false;
      const result = [USER_TYPE.ADMIN, USER_TYPE.SUPER_ADMIN].includes(
        root.$store.getters.account.type
      );
      return result;
    };

    // Filter
    const filterOptions = ref([
      // { text: root.$t("rbu.edition"), value: "edition.id", contains: true },
    ]);

    // Data Table
    const headers = ref([
      { text: root.$t("rbu_volume.name"), value: "name" },
      { text: "", value: "actions", sortable: false, width: 100 },
    ]);
    const innerRefreshTrigger = ref(false);

    const editItem = async function (item) {
      root.$router.push({
        name: "rbu-volume-detail",
        params: { volumeId: item.id },
      });
    };
    const deleteItem = async function (item) {
      if (await root.$dialog.confirm({ text: "Delete RBU Volume?" })) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/volume/delete/",
          params: { volume_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };

    const editVolumeName = async function (item) {
      const result = await root.$dialog.showAndWait(EditRbuVolumeNameDialog, {
        volumeId: item.id,
        volumeName: item.name,
        showClose: false,
        persistent: true,
      });
      if (result) {
        await refresh();
      }
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,

      editItem,
      deleteItem,

      PERMISSIONS,
      canDeleteVolume,
      editVolumeName,
      canEditVolumeName,
    };
  },
};
</script>

<style lang="less"></style>
